module.exports = __webpack_public_path__ + "img/job-offer.c1e57627.svg";